import { Player, PlayerLite } from './model';
import { PlayerDTO, PlayerLiteDTO } from '../interface/apiModels';

export const convertPlayerDTOs = (playerDTOs: PlayerDTO[]): Player[] => {
  return playerDTOs.map(convertPlayerDTO);
};

export const convertPlayerDTO = (playerDTO: PlayerDTO): Player => {
  return {
    ...playerDTO,
    challengeablePlayers: convertPlayerLiteDTOs(playerDTO.challengeablePlayers),
    blockedPlayerDueRevengeBan: convertPlayerLiteDTO(playerDTO.blockedPlayerDueRevengeBan),
    opponent: convertPlayerLiteDTO(playerDTO.opponent),
  };
};

export const convertPlayerLiteDTO = (playerLiteDTO: PlayerLiteDTO): PlayerLite => {
  if (!playerLiteDTO) return null;
  return { ...playerLiteDTO };
};

const convertPlayerLiteDTOs = (playerLiteDTOs: PlayerLiteDTO[]): PlayerLite[] => {
  return playerLiteDTOs.map(convertPlayerLiteDTO);
};
